import css from './H1title.module.scss';
import classNames from 'classnames';

export default function H1title({children, isWhite, center}) {
  return (
    <h1 className={classNames(css.h1, {[css.white]: isWhite, [css.center]: center})}>
      {children}
    </h1>
  );
}